(() => {
  const clean = value => value.replace(/\s+/g, ' ').trim();
  const normalize = value => clean(value.toLowerCase()
    .replace(/(\d+(?:\.\d+)?)\s*(?:feet|foot|ft)\b/g, '$1ft')
    .replace(/pre[\s-]*lit/g, 'prelit').replace(/trees\b/g, 'tree')
    .replace(/[^\p{L}\p{N}.@]+/gu, ' '));
  function hash(text) {
    let h = 2166136261;
    for (const char of text) h = Math.imul(h ^ char.charCodeAt(0), 16777619);
    return (h >>> 0).toString(36);
  }
  function entries(doc, url, pageName) {
    const main = doc.querySelector('main') || doc;
    const selector = '.av-catalog-photo,.av-fit__card,.av-card,details,.av-contact__about,.av-contact__email,.av-contact__details,h1,h2,h3,p,li';
    const units = [...main.querySelectorAll(selector)].filter(el => {
      if (el.closest('[data-av-search],script,style,noscript,[hidden],header.header,footer')) return false;
      const owner = el.parentElement?.closest('.av-catalog-photo,.av-fit__card,.av-card,details,.av-contact__about,.av-contact__email,.av-contact__details');
      return !owner;
    });
    const duplicates = new Map();
    return units.flatMap(el => {
      const text = clean(el.textContent || '');
      if (!text || text.length < 3) return [];
      const key = hash(text), count = duplicates.get(key) || 0;
      duplicates.set(key, count + 1);
      if (!el.id) el.id = 'av-find-' + key + '-' + count;
      const title = clean(el.querySelector('h1,h2,h3,summary')?.textContent || (el.matches('h1,h2,h3') ? text : '')) ||
        clean(el.closest('section')?.querySelector('h1,h2,h3')?.textContent || pageName);
      const group = el.closest('.av-catalog-gallery')?.querySelector('h2')?.textContent || '';
      return [{product:el.matches('.av-catalog-photo'), title, text, group, page:pageName, href:url+'#'+el.id, image:el.querySelector('img')?.getAttribute('src') || ''}];
    });
  }
  function locate() {
    entries(document, location.pathname, document.title);
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id.startsWith('av-find-') && !id.startsWith('AvProduct-')) return;
    const target = document.getElementById(id);
    if (!target) return;
    if (target.matches('details')) target.open = true;
    const detail = target.closest('details'); if (detail) detail.open = true;
    document.querySelectorAll('.av-search-target').forEach(el=>el.classList.remove('av-search-target'));
    target.classList.add('av-search-target');
    requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));
  }
  let indexPromise, indexTime = 0;
  function buildIndex(widget) {
    if (indexPromise && Date.now()-indexTime<60000) return indexPromise;
    indexTime = Date.now();
    indexPromise = (async () => {
      const home = new URL(widget.dataset.home, location.origin);
      const catalog = new URL(widget.dataset.catalog, location.origin);
      const queue = [home.href, catalog.href], seen = new Set(queue), items = [];
      let failures = 0, truncated = false;
      function discover(doc) {
        doc.querySelectorAll('a[href]').forEach(a => {
          let u; try { u = new URL(a.getAttribute('href'), home); } catch { return; }
          if (u.origin!==home.origin || !/\/(pages|policies|blogs|products|collections)(\/|$)/.test(u.pathname)) return;
          u.search='';u.hash='';
          if (seen.has(u.href)) return;
          if (seen.size>=60) {truncated=true;return;}
          seen.add(u.href);queue.push(u.href);
        });
      }
      discover(document);
      while(queue.length) {
        const batch=queue.splice(0,4);
        await Promise.all(batch.map(async url=>{
          try {
            const controller=new AbortController(), timer=setTimeout(()=>controller.abort(),10000);
            let response;
            try { response=await fetch(url,{signal:controller.signal}); } finally {clearTimeout(timer);}
            if(!response.ok)throw new Error('page');
            const doc=new DOMParser().parseFromString(await response.text(),'text/html');
            discover(doc);
            const pathname=new URL(url).pathname;
            const label=url===home.href?'Home':url===catalog.href?'Catalog':
              clean(doc.querySelector('main h1')?.textContent || doc.title || pathname);
            items.push(...entries(doc,pathname,label));
          }catch {failures++;}
        }));
      }
      return {items,partial:failures>0||truncated};
    })().catch(error=>{indexPromise=null;throw error;});
    return indexPromise;
  }
  function init() {
    locate();
    document.querySelectorAll('[data-av-search]').forEach(widget=>{
      if(widget.dataset.ready)return;widget.dataset.ready='true';
      const form=widget.querySelector('form'),input=form.querySelector('input');
      const status=widget.querySelector('.av-search-status'),results=widget.querySelector('.av-search-results');
      let revision=0,timer;
      async function search() {
        const current=++revision,q=normalize(input.value);results.replaceChildren();
        if(!q){status.textContent='Search products, brand information, FAQs, and support.';return;}
        status.textContent='Searching website content…';
        try {
          const {items,partial}=await buildIndex(widget);
          if(current!==revision)return;
          const tokens=q.split(' ');
          const matches=items.map(item=>{
            const words=normalize(item.title+' '+item.text+' '+item.group).split(' ');
            const titleWords=normalize(item.title).split(' ');
            return {...item,score:(item.product?1:0)+tokens.reduce((n,t)=>n+(titleWords.includes(t)?2:0),0),match:tokens.every(t=>words.includes(t))};
          }).filter(x=>x.match).sort((a,b)=>b.score-a.score);
          for(const item of matches) {
            const a=document.createElement('a');a.className='av-search-result';a.href=item.href;
            if(item.image){const img=document.createElement('img');img.src=item.image;img.alt='';img.loading='lazy';a.append(img);}
            const body=document.createElement('span'),title=document.createElement('strong'),detail=document.createElement('small'),where=document.createElement('small');
            title.textContent=item.title;detail.textContent=item.text.length>220?item.text.slice(0,220)+'…':item.text;
            where.textContent='View on '+item.page+' →';body.append(title,detail,where);a.append(body);results.append(a);
          }
          status.textContent=(matches.length?matches.length+' matching results. Select a result to go to that content.':'No matching text found. Try fewer words, or browse the links below.')+
            (partial?' Some pages could not be included.':'');
        }catch{if(current===revision)status.textContent='Search is temporarily unavailable. Please browse the links below.';}
      }
      input.addEventListener('input',()=>{++revision;clearTimeout(timer);timer=setTimeout(search,220);});
      form.addEventListener('submit',event=>{event.preventDefault();clearTimeout(timer);search();});
      search();
    });
  }
  init();
  window.addEventListener('hashchange',locate);
  document.addEventListener('shopify:section:load',()=>{indexPromise=null;init();});
})();
